<template>
    <div class="borrowDetailsBox">
        <Box title="设备借用明细">
            <div class="equipment box">
                <p class="title">设备信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" />
                    <!-- <img :src="equipment.img" @click="showImg(equipment.img)" /> -->
                    <div>
                        <div>
                            <p>资产名称：</p>
                            <p>资产编号：</p>
                            <p>规格型号：</p>
                            <p class="ellipsis">资产序列号：</p>
                        </div>
                        <div>
                            <p class="ellipsis">{{equipment.SBMC}}</p>
                            <p class="ellipsis">{{equipment.SBBH}}</p>
                            <p class="ellipsis">{{equipment.SBXH}}</p>
                            <p class="ellipsis">{{equipment.SBXLH}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis">管理科室：{{equipment.GLKS}}</div>
                    <div class="ellipsis">注册证件号：{{equipment.ZCZJH}}</div>
                </div>
            </div>
            <div class="accessories box">
                <p class="title">配件信息</p>
                <div style="color: #666666;" v-if="accessories.length===0">暂无</div>
                <van-checkbox-group v-model="result">
                    <div class="check-box" v-for="(item, index) in accessories">
                        <van-checkbox :name="index" checked-color="#4fa69e">{{item.PJMC}}</van-checkbox>
                        <span>{{item.BZ}}</span>
                        <!-- <input type="text" placeholder="请输入备注" @input="changeAccessories(index)" /> -->
                    </div>
                </van-checkbox-group>
            </div>

            <div class="borrow box">
                <p class="title">调配信息</p>
                <Field title='申请科室' type='manufacturer' name='departmentList' :text='this.borrow.SQKSMC'
                @manuconfirm='this.borrow.SQKS=arguments[0].a,this.borrow.SQKSMC=arguments[0].b'/>
                <Field title="申请人" :text="borrow.SQR" type="text" />
                <Field title="申请日期" :text="borrow.SQRQ" type="text" />
                <!-- <Field title="使用日期" placeholder="请选择日期" type='calendar' @onMessage="_SYRQ(arguments[0])" /> -->
                <Field title="联系电话" :text="borrow.LXFS" type="text" />
                <!-- <Field title="预计归还日期" placeholder="请选择日期" type="calendar" @onMessage="_YJGHRQ(arguments[0])" /> -->
                <Field title="计费单价" :text="borrow.JFBZ?Number(borrow.JFBZ).toFixed(2):'(请先维护该资产计费标准)'" type="text" />
                 <Field title="申请说明"  type='textarea' :text='borrow.SQBZYY' @onMessage='e=>borrow.SQBZYY=e'/>
            </div>
        </Box>
        <div class="footer">
            <div class="button" @click="upload">提交申请</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import {
        Toast,
        Checkbox,
        CheckboxGroup,
        ImagePreview
    } from 'vant'
    import Field from '@/components/field/field'

    export default {
        name: 'BorrowDetails',
        data() {
            return {
                selectIndex: 0,
                equipment: {}, //    设备信息
                accessories: [], //    配件信息
                result: [], //    选中的配件信息
                resultText: [], //    配件信息备注
                borrow: { //    借用信息
                    SQKS: this.$UserInfo.DepartmentId, //申请科室
                    SQKSMC:this.$UserInfo.DepartmentName,
                    SQR: this.$UserInfo.UserName, //  申请人
                    SQRQ:this.$format(new Date(),'YYYY-MM-DD'),
                    LXFS: this.$UserInfo.Phone, //  联系电话
                    YJGHRQ: null, //  归还日期
                    JFBZ: this.$route.query.Equipment.JFBZ, // 计费单价    该处暂无用
                    SQBZYY: '' //    申请说明
                },
                popup: [], //科室滚动数据集
                outTime: 0, //科室加载延时加载对象
                DepartmentAllObject: null,
                showDiaLog: false
            }
        },
        components: {
            Box,
            Field,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        mounted() {
            this.equipment = this.$route.query.Equipment;
            this.loadPJDefault();
        },
        methods: {
            changeAccessories(index) { //  配件信息备注
                this.resultText[index] = event.target.value
            },
            onMessage(value, key) { //  收到表单消息
                if (!this.borrow[key]) this.borrow[key] = value
            },
            upload() { //提交方法
                let newResult = [];
                for(let i=0;i<this.accessories.length;i++){
                   if(this.result.findIndex(x=>x===i)===-1) newResult.push({CODE:this.accessories[i].Code,REMARK:'',SYZT:'N'});
                   else newResult.push({CODE:this.accessories[i].Code,REMARK:'',SYZT:'Y'});
                }
                var EquipmentModel={
                    SBBH:this.equipment.SBBH,
                    SBMC:this.equipment.SBMC,
                    GGXH:this.equipment.SBXH,
                    LXFS:this.borrow.LXFS,
                    SQR:this.$UserInfo.UserId,
                    SQKS:this.borrow.SQKS,
                    SQRQ:this.borrow.SQRQ,
                    BZ:this.borrow.SQBZYY,
                    }
                   this.UploadAxios(EquipmentModel,newResult);
            },
            loadPJDefault() { //请求获取配件信息
                this.$get('api/DeployEquipment/GetDeployPJList', {
                            SBBH: this.equipment.SBBH
                    })
                    .then(result => {
                        this.accessories = result;
                    })
            },
            _SYRQ(obj) { //使用日期
                this.borrow.SYRQ = obj;
            },
            _YJGHRQ(obj) { //预计归还日期
                this.borrow.YJGHRQ = obj;
            },UploadAxios(EquipmentModel,newResult){//提交方法
                this.$post('api/DeployEquipment/UpdateDeploy', {
                   PJArray:newResult,
                   EquipmentModel:EquipmentModel
                }).then(result => {
                    if(result.code===10000){
                        Toast(result.msg);
                        setTimeout(X=>{
                            this.$router.go(-1);
                        },500);
                    }else{
                        Toast(result.msg);
                    }
                });
             }
        }
    }
</script>

<style scoped lang="scss">
    .borrowDetailsBox {
        padding-bottom: 120px;
    }

    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {

                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #F3F3F3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #F3F3F3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #F3F3F3;

            &:last-child {
                border: none
            }

            .van-checkbox {
                flex: 1;
            }
        }
    }

    .borrow {
        .title {
            margin-bottom: 10px;
        }
    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }
    textarea{
        font-size: 30px;
        width: 100%;
        border: none;
        margin: 0;
        padding: 20px 0;
        &::-webkit-input-placeholder{
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/borrowDetails/borrowDetails.vue